import { useEffect, useState } from 'react'

const TOTAL_SECONDS = 120

interface HumanModeCountdownProps {
  startedAt: number
}

export function HumanModeCountdown({ startedAt }: HumanModeCountdownProps) {
  const [secondsLeft, setSecondsLeft] = useState(() => {
    const elapsed = Math.floor((Date.now() - startedAt) / 1000)
    return Math.max(0, TOTAL_SECONDS - elapsed)
  })

  useEffect(() => {
    const tick = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startedAt) / 1000)
      setSecondsLeft(Math.max(0, TOTAL_SECONDS - elapsed))
    }, 1000)
    return () => clearInterval(tick)
  }, [startedAt])

  const minutes = Math.floor(secondsLeft / 60)
  const secs = secondsLeft % 60
  const display = `${minutes}:${String(secs).padStart(2, '0')}`
  const progress = secondsLeft / TOTAL_SECONDS

  return (
    <div className='mx-auto my-3 w-full max-w-[280px] overflow-hidden rounded-[22px] bg-white/80 shadow-[0_4px_24px_rgba(0,0,0,0.08),0_0_0_0.5px_rgba(0,0,0,0.05),inset_0_1px_0_rgba(255,255,255,1)] backdrop-blur-2xl'>
      <div className='flex items-center gap-3.5 px-5 pb-4 pt-5'>
        <div className='flex h-10 w-10 shrink-0 items-center justify-center rounded-[12px] bg-linear-to-br from-[#32ADE6] to-[#1A7FAD] shadow-sm'>
          <span className='text-xl leading-none'>🕐</span>
        </div>
        <div>
          <p className='text-[15px] font-semibold text-black'>Checking availability</p>
          <p className='text-[13px] text-[#6C6C70]'>Contact form in {display}</p>
        </div>
      </div>

      {/* Progress bar */}
      <div className='mx-4 mb-5 h-1.5 overflow-hidden rounded-full bg-[rgba(120,120,128,0.12)]'>
        <div
          className='h-full rounded-full bg-[rgba(0,0,0,0.15)] transition-all duration-1000 ease-linear'
          style={{ width: `${progress * 100}%` }}
        />
      </div>
    </div>
  )
}
